// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","753":"component---src-pages-savings-js","940":"937911d241d7f3ea2546b91f06eb775f38ce2a9b"}[chunkId] + "-" + {"532":"86803e223b3716dcd07c","678":"a2eff687ad333bfdb7cd","753":"4f093e24bcee625926e3","940":"9b1a2b8e822d370a5087"}[chunkId] + ".js";
};